import { render, staticRenderFns } from "./buy-residential-proxy-view.vue?vue&type=template&id=49994dc5&scoped=true"
import script from "./buy-residential-proxy-view.vue?vue&type=script&lang=js"
export * from "./buy-residential-proxy-view.vue?vue&type=script&lang=js"
import style0 from "./buy-residential-proxy-view.vue?vue&type=style&index=0&id=49994dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49994dc5",
  null
  
)

export default component.exports